(() => {
  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;

    const tabs = [...root.querySelectorAll('.ibs__tab')];
    const mobileSelector = root.querySelector('[data-mobile-selector]');
    const label = root.querySelector('[data-result-label]');
    const title = root.querySelector('[data-result-title]');
    const body = root.querySelector('[data-result-body]');
    const productLink = root.querySelector('[data-product-link]');
    const readLink = root.querySelector('[data-read-link]');
    const image610 = root.querySelector('[data-product-image-610]');
    const image630 = root.querySelector('[data-product-image-630]');

    if (!tabs.length || !label || !title || !body || !productLink || !readLink) return;

    root.dataset.ready = 'true';

    const productUrls = {
      '610': root.dataset.ion610Url,
      '630': root.dataset.ion630Url,
    };
    const productLabels = {
      '610': root.dataset.ion610Label || 'View ION610',
      '630': root.dataset.ion630Label || 'View ION630 Vienne',
    };

    const selectTab = (tab) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });

      if (mobileSelector) mobileSelector.value = String(tabs.indexOf(tab));

      const model = tab.dataset.model;
      label.textContent = tab.dataset.label;
      title.textContent = tab.dataset.title;
      body.textContent = tab.dataset.body;
      productLink.textContent = productLabels[model];
      productLink.href = productUrls[model] || '#';
      readLink.href = tab.dataset.readUrl || '#';

      if (image610) image610.classList.toggle('is-hidden', model !== '610');
      if (image630) image630.classList.toggle('is-hidden', model !== '630');
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        const supportedKeys = ['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'];
        if (!supportedKeys.includes(event.key)) return;

        event.preventDefault();
        const direction = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + direction + tabs.length) % tabs.length];
        next.focus();
        selectTab(next);
      });
    });

    if (mobileSelector) {
      mobileSelector.addEventListener('change', () => {
        const selectedTab = tabs[Number(mobileSelector.value)];
        if (selectedTab) selectTab(selectedTab);
      });
    }

    selectTab(tabs[0]);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-ionmax-back-stock]')) init(scope);
    scope.querySelectorAll?.('[data-ionmax-back-stock]').forEach(init);
  };

  if (window.IonmaxBackStock?.initAll) {
    window.IonmaxBackStock.initAll();
    return;
  }

  window.IonmaxBackStock = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
